import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { industries } from '../altiora-mock';
import { Factory, Heart, Laptop, ShoppingBag } from 'lucide-react';

const iconMap = {
  Factory: Factory,
  Heart: Heart,
  Laptop: Laptop,
  ShoppingBag: ShoppingBag
};

const AltioraIndustries = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-br from-gray-50 to-teal-50 py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Industries We Serve</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Specialized accounting solutions across diverse sectors
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {industries.map((industry) => {
              const Icon = iconMap[industry.icon] || Factory;
              return (
                <Card key={industry.id} className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-teal-500">
                  <CardContent className="p-8 space-y-4">
                    <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center group-hover:bg-teal-600 transition-colors">
                      <Icon className="w-8 h-8 text-teal-600 group-hover:text-white transition-colors" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-900">{industry.name}</h2>
                    <p className="text-gray-600 leading-relaxed">{industry.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          {/* Additional Info */}
          <div className="mt-16 bg-gradient-to-br from-gray-50 to-teal-50 rounded-2xl p-8 md:p-12">
            <div className="max-w-3xl mx-auto text-center space-y-6">
              <h2 className="text-3xl font-bold text-gray-900">
                Your Industry Not Listed?
              </h2>
              <p className="text-lg text-gray-600">
                We work with businesses across various sectors. Our flexible approach allows us to adapt our services to meet the unique needs of your industry. Contact us to discuss how we can support your business.
              </p>
            </div>
          </div>

          {/* Industry Expertise */}
          <div className="mt-16">
            <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
              Why Industry Expertise Matters
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <Card className="border-2">
                <CardContent className="p-6 space-y-3">
                  <div className="text-4xl font-bold text-teal-600">01</div>
                  <h3 className="text-xl font-bold text-gray-900">Compliance Knowledge</h3>
                  <p className="text-gray-600">
                    We understand industry-specific regulations and compliance requirements.
                  </p>
                </CardContent>
              </Card>
              
              <Card className="border-2">
                <CardContent className="p-6 space-y-3">
                  <div className="text-4xl font-bold text-teal-600">02</div>
                  <h3 className="text-xl font-bold text-gray-900">Tailored Solutions</h3>
                  <p className="text-gray-600">
                    Our processes are customized to address your industry's unique challenges.
                  </p>
                </CardContent>
              </Card>
              
              <Card className="border-2">
                <CardContent className="p-6 space-y-3">
                  <div className="text-4xl font-bold text-teal-600">03</div>
                  <h3 className="text-xl font-bold text-gray-900">Best Practices</h3>
                  <p className="text-gray-600">
                    We apply industry best practices to maximize efficiency and results.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AltioraIndustries;
